module.exports = __webpack_public_path__ + "img/join_wealth.190c5b16.svg";